import React, { useState, useEffect } from 'react';
import axios from 'axios';
import requests from '../services/tmdb';
import './Banner.css';

function Banner({ onOpenModal }) {
  const [movie, setMovie] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const request = await axios.get(requests.fetchNetflixOriginals);
      setMovie(request.data.results[Math.floor(Math.random() * request.data.results.length)]);
    }
    fetchData();
  }, []);

  return (
    <header className="banner" style={{
      backgroundSize: "cover",
      backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
      backgroundPosition: "center center",
    }}>
      <div className="banner__contents">
        <h1 className="banner__title">{movie?.title || movie?.name}</h1>
        <div className="banner__buttons">
          <button className="banner__button" onClick={() => onOpenModal(movie)}>Assistir</button>
          <button className="banner__button">Minha Lista</button>
        </div>
        <h1 className="banner__description">{movie?.overview}</h1>
      </div>
      <div className="banner--fadeBottom" />
    </header>
  );
}

export default Banner;
